import { Injectable } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CancelStatusChangeComponent } from '../components/cancel-status-change/cancel-status-change.component';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { FormGroup, } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { CityModel } from '../business-entities/customer-view.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AdminCommonService {
  cityList: CityModel[];
  postCodeRawData: any;
  cityName: string;
  postcodeName: string;
  accountForm: FormGroup;
  postCodeList: any;
  countryList: any;
  countryId: number;
  countryName: string;
  
  constructor(
    private datePipe :DatePipe,
    private modalService :NgbModal,
    public pService: CustomPaggerService,
    private toastr: ToastrService,
    private translate : TranslateService,
    ) { }

   // for common modal use in component
   openStatusChangeModal(appointmentId: number, WOnumber: string, isOpenByOtherUser: boolean, appointmentType: string, appointmentGuid: string) {
    const modalref = this.modalService.open(CancelStatusChangeComponent, {
      size: 'lg',
      windowClass: 'pop-wid800',
    });
    // Set modal component properties
    modalref.componentInstance.appointmentId = appointmentId;
    modalref.componentInstance.workOrderNumber = WOnumber;
    modalref.componentInstance.isLockedByOtherUser = isOpenByOtherUser;
    modalref.componentInstance.appointmentType = appointmentType;
    modalref.componentInstance.appointmentGuid = appointmentGuid;
  
    return modalref.result;
  }
  
   getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC || reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

    /**
* Method to generate auto row number based on per page size
* @param cIndex
*/
 currentPageNumber(cIndex: number): number {
  let rtPageNumber = 0;
  if (this.pService.page === 1) {
    rtPageNumber = cIndex + 1;
  }
  else if (this.pService.page > 1) {
    rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
  }

  return rtPageNumber;
}
// to get formated date
getWeekViewDates(startDay: number): { weekViewDate: string; bookingDate: any } {
  let current = new Date();
  let d = current.getDay();
  let weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000);
  let weekEnd = new Date(weekStart.valueOf() + 6 * 86400000);
  let weekViewDate =
    this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
  let bookingDate = {
    beginDate: { year: weekStart.getFullYear(), month: weekStart.getMonth() + 1, day: weekStart.getDate() },
    endDate: { year: weekEnd.getFullYear(), month: weekEnd.getMonth() + 1, day: weekEnd.getDate() },
    formatted: weekViewDate,
  };
  return { weekViewDate, bookingDate };
}

getWeekViewDatesNew(startDay: number): { weekViewDate: string; bookingDate: any[] } {
  let current = new Date();
  let d = current.getDay();
  let weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000);
  let weekEnd = new Date(weekStart.valueOf() + 6 * 86400000);
  let weekViewDate =
    this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
  let bookingDate: any[]= [];
  bookingDate.push(weekStart);
  bookingDate.push(weekEnd);
  return { weekViewDate, bookingDate };
}

showUnassociatedChildServiceWarning(childServiceList: string) {
  const warningmsg = this.translate.instant("lblPleaseAlsoAssociateChildServices");
  const msg = this.translate.instant("lblCustomerWillnotAbletoProcess");
  const completeMsg = `${warningmsg} ${childServiceList} ${msg}`;
  this.toastr.warning(completeMsg);
}

}
